"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// This function has been copied from EA code, move this to shared utils in toolkit once it is there

/* eslint-disable prefer-rest-params */

/**
 * Returns a function, that, as long as it continues to be invoked, will not be triggered.
 * The callback will be called after it stops being called for N milliseconds.
 *
 * @param {function} callback
 * @param {number} delay
 * @param {boolean} leading
 * @param {boolean} trailing
 * @returns {function}
 */
var debounce = function debounce(callback, delay) {
  var leading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var trailing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var timeout = null;
  var called = 0;
  var result; // note: debounced function should not be arrow

  return function () {
    // debounce anything except leading
    if (leading && !called) {
      result = callback.apply(this, arguments);
    }

    called += 1;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      // debounce anything except trailing
      if (trailing && (!leading || called > 1)) {
        callback.apply(this, arguments);
      }

      timeout = null;
      called = 0;
    }, delay);
    return result;
  };
};

var _default = debounce;
/* eslint-enable prefer-rest-params */

exports.default = _default;